import React from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

/**
 * Confirms recording attendance, for either outcome.
 *
 * The members are listed by name rather than counted: a count confirms which
 * button was pressed, not who was ticked, and a mis-tick in a long list of
 * similar names is the mistake worth catching. The list scrolls, so a seventy
 * person class stays readable instead of running off the screen.
 *
 * Attendance cannot be undone once saved -- the row locks and there is no
 * history table -- so both outcomes ask, not just No Show.
 */
export default function MarkAttendanceConfirmModal(props) {
  const {
    modal,
    toggle,
    onConfirm,
    members = [],
    outcome = "Attended",
    classTitle = "this class",
  } = props;

  const isNoShow = outcome === "No Show";

  // reactstrap draws its own close button, which is dark and invisible against
  // the header. Supplying one keeps the white-on-slate header of the other
  // modals in this module.
  const closeBtn = (
    <button
      type="button"
      className="close text-white"
      style={{ opacity: 1, textShadow: "none" }}
      onClick={toggle}
    >
      &times;
    </button>
  );

  return (
    <Modal
      centered={true}
      autoFocus={true}
      isOpen={modal}
      toggle={toggle}
      backdrop="static"
    >
      <ModalHeader
        toggle={toggle}
        close={closeBtn}
        className="bg-secondary text-white py-2"
        tag="h5"
      >
        Mark {outcome}
      </ModalHeader>
      <ModalBody>
        <div className="col-12">
          <h5 className="mt-0">
            Record {members.length}{" "}
            {members.length === 1 ? "member" : "members"} as <b>{outcome}</b>{" "}
            for {classTitle}?
          </h5>
          <div
            className="border rounded bg-light px-3 py-2 my-3"
            style={{ maxHeight: "260px", overflowY: "auto" }}
          >
            {members.map((m) => (
              <div key={m.registrationId} className="font-weight-bold">
                {m.firstName} {m.lastName}
                {m.memberNumber ? ` - ${m.memberNumber}` : ""}
              </div>
            ))}
          </div>
          <p className="text-muted mb-0">
            This cannot be changed once saved. No email is sent to the member.
          </p>
        </div>
      </ModalBody>
      <ModalFooter>
        {/* The colour has to come from `color`, not className: reactstrap adds
            btn-secondary from the default prop and it wins, which is why both
            buttons came out grey. */}
        <Button
          color={isNoShow ? "danger" : "success"}
          className="w-md waves-effect waves-light"
          onClick={onConfirm}
        >
          Yes, mark {outcome}
        </Button>{" "}
        <Button color="primary" onClick={toggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
}
